var shared = require('../internals/shared')('keys');
var uid = require('../internals/uid');

module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/client-logger/~/core-js/internals/shared-key.js
// module id = 486
// module chunks = 168707334958949